export default "__VITE_ASSET__o9aBObR3__"